import React, { useState } from 'react';
import './css/Header_White.css'
import HeaderBase from './Header_White';



function Header(props) {
    const [remainingHeight, setRemainingHeight] = useState(0);
    const [Display, setDisplay] = useState('none');
    const isWhiteBack = props.isWhiteBack;

    const handleHover = (height) => {
        setRemainingHeight(height);
        setDisplay('block');

    };
    const handleHoverEnd = () => {
        setDisplay('none');
    };
    
    return (
        <div>
            <HeaderBase onHover={handleHover} onHoverEnd={handleHoverEnd} isWhiteBack={isWhiteBack} />
            {/* <HeaderBase  isWhiteBack={isWhiteBack} /> */}
            <div style={{ zIndex: 2, display: Display, position: 'fixed', bottom: 0, left: 0, right: 0, height: remainingHeight, backgroundColor: 'black', width: '100%', opacity: 0.6 }} />
        </div>

    );
}

export default Header;